import Vue from 'vue'

// actions
var actions = {
  // 保存文章
  save: { method: 'POST', url: '@shareapi/fxsk/shareproduct/saveajax' },
  // 获取消息
  getMyContents: { method: 'GET', url: '/products/getMyContents' },
  getPlatformContents: { method: 'GET', url: '/products/getPlatformContents' },
  getLastContents: { method: 'GET', url: '/products/getLastContents' }
}

export default Vue.resource('/products{/id}', {}, actions)



// WEBPACK FOOTER //
// ./src/api/products.js